module.exports = __webpack_public_path__ + "img/wide.357df60e.jpg";